/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function DeliveryItemSearchViewController(this: JS5Object, _: JS5Object, $location: JS5Object, $q: JS5Object,
                                          $routeParams: JS5Object, uiGridConstants: JS5Object,
                                          PartnerEditService: JS5Object, ModalService: JS5Object,
                                          NotificationService: JS5Object, PaginationService: JS5Object,
                                          UtilsService: JS5Object, DeliveryItemsService: JS5Object): void {

    const getData = () => {
        this.loadingIndicator.show = true;
        PartnerEditService.getDeliveryItemsForProfile({
            fetchLimit: this.pagingOptions.pageSize,
            fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
            profileId: $routeParams.deliveryProfileId,
            includeHidden: this.showHidden,
            acceptProfileId: $routeParams.mediaAcceptProfileId,
            type: this.deliveryItemType === 'Artwork' ? 'Image' : this.deliveryItemType,
            artwork: this.deliveryItemType === 'Artwork'
        }).then((deliveryItems: JS5Object) => {
            this.gridOptions.data = deliveryItems;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: (newValue: boolean) => {
                this.showHidden = newValue;
                getData();
            },
            isChecked: this.showHidden,
        },
    ];


    const buildEditViewUrl = (id: string) => {
        return `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${$routeParams.mediaAcceptProfileId}/${this.deliveryItemType}/edit/${id}`;
    };

    const navigateToDeliveryItemsVideosEditViewFromDoubleClick = (row: JS5Object): void => {
        $location.url(buildEditViewUrl(row.id));
    };

    this.onRowDblClick = (row: JS5Object) => {
        if (!row.entity.hidden) {
            navigateToDeliveryItemsVideosEditViewFromDoubleClick(row.entity);
        }
    };

    const navigateToCreateView = () => {
        $location.url(buildEditViewUrl('-1'));
    };

    const navigateToEditViewFromEditButton = () => {
        $location.url(buildEditViewUrl(_.first(this.gridApi.selection.getSelectedRows()).id));
    };

    const getSelectedDeliveryItem = () => {
        return _.cloneDeep(_.first(this.gridApi.selection.getSelectedRows()));
    };
    const toggleHiddenOkHandler = () => {
        let deliveryItem = getSelectedDeliveryItem();
        this.loadingIndicator.show = true;
        PartnerEditService.toggleDeliveryItemHidden(deliveryItem.id).then(() => {
            const successNotification = `Delivery Item successfully ${deliveryItem.hidden ? 'unhidden' : 'hidden'}!`;
            NotificationService.createSuccessNotification(successNotification);
            getData();
        }).catch(() => {
            const failureNotification = `Could not ${deliveryItem.hidden ? 'unhide' : 'hide'} Delivery Item!`;
            NotificationService.createFailureNotification(failureNotification);
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const toggleItemHidden = () => {
        let deliveryItem = getSelectedDeliveryItem();
        const messageText = `Are you sure you want to ${deliveryItem.hidden ? 'unhide' : 'hide'} this Delivery Item?`;
        const title = `${deliveryItem.hidden ? 'Unhide' : 'Hide'} Delivery Item`;
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, toggleHiddenOkHandler);
    };

    const cloneOnOkHandler = () => {
        this.loadingIndicator.show = true;
        PartnerEditService.cloneDeliveryItem(getSelectedDeliveryItem().id).then(() => {
            NotificationService.createSuccessNotification('Delivery item successfully cloned!');
            getData();
        }).catch(() => {
            NotificationService.createFailureNotification('Could not clone delivery item!');
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const cloneItem = () => {
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to clone the selected Delivery Item?',
            pullCancelLeft: true,
            title: 'Clone Delivery Item',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, cloneOnOkHandler);
    };

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: DeliveryItemsService.getSearchViewColumnDefinitions(this.deliveryItemType),
        onRegisterApi: (gridApi: JS5Object): void => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: navigateToCreateView
        },
        {
            label: 'Edit',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: navigateToEditViewFromEditButton
        },
        {
            label: 'Clone',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: cloneItem
        },
        {
            label: 'Hide',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: toggleItemHidden
        },
        {
            label: 'Unhide',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: toggleItemHidden
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        initPaging();
        getData();
    };
    this.onPaginationChanged = () => {
        getData();
    };
    this.paginationJumpToPageHandler = () => {
        this.onPaginationChanged();
    };

    this.paginationPageSizeChanged = () => {
        this.pagingOptions.currentPage = 1;
        this.onPaginationChanged();
    };

    this.paginationPrevPageHandler = () => {
        --this.pagingOptions.currentPage;
        this.onPaginationChanged();
    };

    this.paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        this.onPaginationChanged();
    };

    const initPaging = () => {
        this.pagingOptions = PaginationService;
        this.pagingOptions.currentPage = 1;
        this.pagingOptions.pageSize = UtilsService.constants.DEFAULT_FETCH_LIMIT;

        this.paginationDefs = {
            paginationPrevPageHandler: this.paginationPrevPageHandler,
            paginationNextPageHandler: this.paginationNextPageHandler,
            paginationPageSizeChanged: this.paginationPageSizeChanged,
            paginationJumpToPageHandler: this.paginationJumpToPageHandler,
            pagingOptions: PaginationService
        };
    };
}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemSearchView', {
    controller: DeliveryItemSearchViewController,
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/searchView/delivery-item-search-view-template.html',
    bindings: {
        deliveryItemType: '<',
    }
});
